import {FormGroup, FormControl, FormBuilder, Validators, AbstractControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {isNumber} from 'util';


export function validateEmpty(control: FormControl) {

    if ((control.value == null ) || (control.value != null && control.value.toLocaleString().trim() == '')) {
      return { errors: true };
    }
  return null;
}

